module.exports = __webpack_public_path__ + "static/media/hero dostawcze.eb924546.png";